import {FormBase} from '../../components/formsBase/formBase';

/**
 * React functional component representing the base layout for the Symptoms pages.
 * @component
 * @param {Object} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The content to be rendered within the SymptomsBase.
 * @param {string} props.pageNumber - The current page number.
 * @param {Function} props.handleBack - The function to handle the "Back" action.
 * @param {Function} props.handleNext - The function to handle the "Next" action.
 * @param {string} props.backButtonName - The label for the "Back" button.
 * @param {string} props.nextButtonName - The label for the "Next" button.
 * @returns {JSX.Element} The rendered SymptomsBase component.
 */
export const SymptomsBase = ({children, ...props}) => {
  return (
    <FormBase {...props} pageNames={['About You', 'Symptom Checker', 'Results']}>
      {children}
    </FormBase>
  );
};
